import React from "react";
import Button from "react-bootstrap/esm/Button";
import ListGroup from "react-bootstrap/esm/ListGroup";
import { turkishCurrencyFormatterNoPrecision } from "../utils";

export default function ProductsList(props) {
  const { features, product, setFeature, setFeatures, setProduct } = props;

  return (
    <div
      className="bg-white scrollbar scrollbar-primary"
      style={{ overflow: "auto", overflowX: "hidden", height: "100%" }}
    >
      <ListGroup>
        {features.map((f) => {
          return (
            <ListGroup.Item
              key={f._id}
              action
              onClick={() => {
                setFeature(f);
              }}
            >
              <div>
                <h5 style={{ display: "inline" }}>
                  {f.name + " " + product.name}
                </h5>
                &nbsp;&nbsp;&nbsp;
                <span>
                  {turkishCurrencyFormatterNoPrecision(product.price + f.price)}
                </span>
              </div>
            </ListGroup.Item>
          );
        })}
        <ListGroup.Item
          action
          onClick={() => {
            setProduct("");
            setFeature("");
            setFeatures([]);
          }}
        >
          <Button variant="danger">
            <i className="fas fa-caret-left"></i>&nbsp;
            {"Çık"}
          </Button>
        </ListGroup.Item>
      </ListGroup>
    </div>
  );
}
